// removed by extract-text-webpack-plugin
module.exports = {"container":"event-payment__container__3puHP","ticket-title":"event-payment__ticket-title__3nTYg","price":"event-payment__price__2SOz_","refund-policy":"event-payment__refund-policy__26cu1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/event-payment.scss
// module id = 1397
// module chunks = 1